import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  inputStepper: {
    display: `flex`
  },
  inputStepperSelectFormControl: {
    margin: theme.spacing(1),
    marginRight: theme.spacing(6)
  },
  inputStepperSelectLabel: {
    width: `5em`,
    "& .MuiOutlinedInput-input": {
      padding: theme.spacing(1)
    }
  },
  inputStepperLabel: {
    flexBasis: `5em`,
    display: `flex`,
    textAlign: `right`,
    flexDirection: `column`,
    justifyContent: `center`,
    marginRight: theme.spacing(1)
  },
  inputStepperIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.dark
  },
  inputStepperTextField: {
    flexGrow: 1,
    marginRight: theme.spacing(1),
    "& .MuiOutlinedInput-input": {
      padding: theme.spacing(1)
    },
    "& .MuiInputLabel-shrink": {
      transform: `translate(14px, 0px) scale(0.75)`
    },
    display: `flex`,
    flexDirection: `column`,
    justifyContent: `center`
  },
  inputStepperSelectTextField: {
    flexGrow: 1,
    marginRight: theme.spacing(1),
    "& .MuiOutlinedInput-input": {
      padding: theme.spacing(1)
    },
    "& .MuiInputLabel-shrink": {
      transform: `translate(14px, 2px) scale(0.75)`
    },
    display: `flex`,
    fledDirection: `column`,
    justifyContent: `center`
  }
}));

export default useStyles;
